import {
  HOST_ORDER_VERIFIED,
  HOST_ORDER_COLLECTED,
  BUYER_ORDER_UNPAID,
  HOST_ORDER_SUBMITTED_VERIFIED,
  HOST_ORDER_SUBMITTED_COLLECTED,
  BUYER_ORDER_PAID,
} from '_utils/constant'

export const STATUS_MAP = {
  pending: [{ value: BUYER_ORDER_PAID, label: 'Pending Review', isPending: true }],
  collected: [{ value: HOST_ORDER_COLLECTED, label: 'Collected', type: 'host', includeSubmitted: HOST_ORDER_SUBMITTED_COLLECTED }],
  paid: [{ value: HOST_ORDER_VERIFIED, label: 'Verified', type: 'host', includeSubmitted: HOST_ORDER_SUBMITTED_VERIFIED }],
  unpaid: [{ value: BUYER_ORDER_UNPAID, label: 'Not Paid' }],
}

export const mapDashboardStatusToPaymentStatus = (status) => STATUS_MAP[status] || []
